@if (isLoggedIn) {
<div class="md:hidden">
  <nav
    class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-md pb-[env(safe-area-inset-bottom)] select-none touch-manipulation">
    <div class="grid" [style.gridTemplateColumns]="'repeat(' + navItems.length + ', 1fr)'">
      @for (item of navItems; track $index) {
      <div class="relative">
        <a (click)="navigateTo(item)"
          class="flex flex-col items-center justify-center h-16 py-2 px-1 text-xs cursor-pointer transition-colors duration-100 ease-in-out no-underline select-none active:opacity-70"
          [ngClass]="{
               'bg-metro-secondary': isActive(item.path),
               'text-black': true
             }">
          <app-metro-icon [svg]="item.iconSvg" [color]="'#1C2D36'" class="w-6 h-6 mb-1 transition-colors duration-200"
            [ngClass]="{'icon-bold': isActive(item.path)}">
          </app-metro-icon>
          <span class="leading-tight font-medium" [ngClass]="{'font-bold': isActive(item.path)}">
            {{ item.label | abpLocalization }}
          </span>
          <!-- Espacio reservado para la barra para evitar saltos de altura -->
          <span class="mt-1 h-1 w-6 rounded-full transition-all duration-300"
            [ngClass]="isActive(item.path) ? 'bg-[#1C2D36] opacity-100' : 'bg-transparent opacity-0'"></span>
        </a>

        @if (item.children && isMenuOpen(item.id ?? item.path)) {
        <div
          class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-40 bg-white border border-gray-200 shadow-lg rounded-md flex flex-col z-50">
          @for (child of item.children; track $indexChild) {
          <a (click)="navigateTo(child)" class="py-2 px-3 text-sm hover:bg-gray-100 no-underline">
            {{ child.label | abpLocalization }}
          </a>
          }
        </div>
        }
      </div>
      }
    </div>
  </nav>
</div>
}